<template>
  <div class="filter-unit deletable" ref="btn" @click="togglePopup">
    <span class="filter-unit-key">{{ filterUnit.key }}</span>
    <span class="filter-unit-operator">{{ filterUnit.operator }}</span>
    <span class="filter-unit-value">{{ filterUnit.value }}</span>
    <SvgIcon
      icon="cross"
      class="filter-unit-delete"
      @click.stop="deleteFilterUnit"
    />
  </div>

  <teleport to="#popup-container">
    <div class="filter-popup" ref="popup" v-show="isOpen" style="width: 321px;">
      <div class="triangle"></div>
      <h5 class="title">{{ filterUnit.key }}</h5>
      <div class="filter-field">
        <span class="filter-field-name">運算子</span>
        <DropdownList
          :items="['==', '!=']"
          :defaultValue="filterUnit.operator"
          @change="onOperatorChange"
        />
      </div>
      <div class="filter-field">
        <span class="filter-field-name">值</span>
        <!-- 值為可選：下拉選單 -->
        <DropdownList
          v-if="filterUnit.options.length > 0"
          :items="filterUnit.options"
          :defaultValue="filterUnit.value"
          @change="onDropdownValueChange"
        />
        <!-- 值不可選：輸入框 -->
        <input
          v-else
          class="form-control filter-popup-input"
          type="text"
          :value="currentValue"
          @input="onInputValueChange"
        />
      </div>
      <div class="divider"></div>
      <button
        class="btn btn-primary filter-btn filter-btn-apply"
        :disabled="isBtnDisabled"
        @click="updateFilterUnit"
      >
        套用
      </button>
      <button
        class="btn btn-outline-light filter-btn filter-btn-cancel"
        @click="cancelSelected"
      >
        取消
      </button>
    </div>
  </teleport>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from 'vue'
import DropdownList from '@/components/Dropdown/DropdownList.vue'
import useFilterPopup from '@/composable/useFilterPopup'

export default defineComponent({
  components: {
    DropdownList
  },
  props: {
    filterUnit: Object
  },
  emits: ['updateFilterUnit', 'deleteFilterUnit'],
  setup(props, ctx) {
    const { isOpen, togglePopup, btn, popup } = useFilterPopup()

    //@ts-ignore
    const currentOperator = ref(props.filterUnit.operator) // 紀錄目前選取的運算子
    //@ts-ignore
    const currentValue = ref(props.filterUnit.value) // 紀錄目前選取 or 輸入的值
    const onOperatorChange = item => (currentOperator.value = item)
    const onDropdownValueChange = item => (currentValue.value = item)
    const onInputValueChange = e => (currentValue.value = e.target.value)

    // 套用按鈕狀態
    const isBtnDisabled = computed(() => {
      if (props.filterUnit) {
        return (
          props.filterUnit.operator == currentOperator.value &&
          props.filterUnit.value == currentValue.value
        )
      }
      return true
    })
    const cancelSelected = () => {
      isOpen.value = false
    }
    const updateFilterUnit = () => {
      // 更新 filterUnit
      if (props.filterUnit) {
        ctx.emit('updateFilterUnit', {
          id: props.filterUnit.id,
          key: props.filterUnit.key,
          operator: currentOperator.value,
          value: currentValue.value,
          options: props.filterUnit.options
        })
      }
      isOpen.value = false
    }
    const deleteFilterUnit = () => {
      // 刪除此 filterUnit
      if (props.filterUnit) {
        ctx.emit('deleteFilterUnit', props.filterUnit.id)
      }
    }

    return {
      // Popup 相關
      isOpen,
      togglePopup,
      btn,
      popup,
      // Dropdown 相關
      onOperatorChange,
      onDropdownValueChange,
      onInputValueChange,
      currentValue,
      isBtnDisabled,
      cancelSelected,
      // 資料相關
      updateFilterUnit,
      deleteFilterUnit
    }
  }
})
</script>

<style scoped></style>
